//groupCode
export const FETCH_BUYER_GROUPS = 'FETCH_BUYER_GROUPS';
export const FETCH_BUYER_GROUPS_SUCCESS = 'FETCH_BUYER_GROUPS_SUCCESS';
export const FETCH_BUYER_GROUPS_ERROR = 'FETCH_BUYER_GROUPS_ERROR';
